import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { Column } from "../../../Components/Tables/Table";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import useEventSystem from "../../../events/useEventSystem";
import { formatNumber, prepareSearchColumns } from "../../../Utility/Utility";
import PickList from "../List/PickList";
import CommonModal from "../../../Components/Modals/CommonModal";
import AssignToUserLayout from "../../../Layout/AssignToUserLayout";
import { deletePickTicketById } from "./service/pickOverview.service";
import { ApiResponse } from "../../../model/common/apiResponse";
import toast from "react-hot-toast";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";

interface OutboundPickProps {
  pageName: string;
  headerName: string;
}

const defaultProps: OutboundPickProps = {
  pageName: "Pick",
  headerName: "Picks",
};

export default function PickOverview(props: OutboundPickProps) {
  const { pageName, headerName } = props;
  const [clientId, setClientId] = useState<any>(null);
  const navigation = useNavigate();
  const { resetSearch } = useSearchStore();
  const [loading, setLoading] = useState(true);
  const { emit } = useEventSystem();
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedPickId, setSelectedPickId] = useState<number | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

 // const { getSelectedClient } = useClientStore();
   const [confirmModalData, setConfirmModalData] = useState({
    id: 0,
    showconfModal: false,
    message: "",
  });
  const db_columns = [
    { data: "pick_ticket.id" },
    { data: "pick_ticket.pick_number" },
    { data: "pick_ticket.no_of_lines" },
    { data: "pick_ticket.total_qty" },
    { data: "picked_qty" },
    { data: "warehouse_area.name as pick_area" },
    { data: "warehouse_area.name" },
    { data: "pick_ticket.pick_method" },
    { data: "assigned_to_user.name as assigned_to" },
    { data: "pick_ticket.status" }
  ];

  const exclude_columns = [
    "pick_ticket.no_of_lines",
    "pick_ticket.total_qty",
    "picked_qty",
  ];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);

  const columns: Column[] = [
    {
      name: "Pick Ticket #",
      selector: (row: any) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row.id)}
        >
          {row.pick_number}
        </span>
      ),
      column_name: "pick_ticket.pick_number",
      enableSorting: true,
    },
    {
      name: "No. of Lines",
      selector: (row: any) => row.no_of_lines,
    },
    {
      name: "Total Qty",
      selector: (row: any) => formatNumber(row.total_qty),
    },
    {
      name: "Picked Qty",
      selector: (row: any) => formatNumber(row.picked_qty),
    },
    {
      name: "Pick Area",
      selector: (row: any) => row.warehouse_area?.name || "-",
    },
    {
      name: "Pick Method",
      selector: (row: any) => row.pick_method,
    },
    {
      name: "Assigned To",
      selector: (row: any) => row.assigned_to_user?.name || "-",
    },
    {
      name: (
        <>
          <ArrowLeftRight
            className="me-2"
            style={{ stroke: "black", strokeWidth: 1 }}
          />
          <PlusCircle style={{ stroke: "black", strokeWidth: 1 }} />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none ms-4"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleRowClick(row.id)}
            >
              View
            </li>
            <li 
              className={`cursor-pointer ms-3 mb-1 fs-14 fw-bold d-block ${row.status !== "ready to pick" ? "d-none" : ""}`}
              onClick={() => handleDeleteAction(row)}
            >
              Delete
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelAssignAction(row.id)}
            >
              Assign
            </li>
            <li className="cursor-pointer ms-3 mb-1 fs-14 fw-bold">Start Picking</li>
          </ul>
        </>
      ),
      enableSorting: false,
    },
  ];

  // useEffect(() => {
  //   const subscriptionClient = getSelectedClient().subscribe((client) => {
  //     setClientId(client?.id);
  //   });

  //   return () => {
  //     subscriptionClient.unsubscribe();
  //   };
  // }, [getSelectedClient]);

  const handleRowClick = (data: any) => {
    return navigation(`/outbound/pick/details/${data}`);
  };

  const handelAssignAction = (pickId: number) => {
    setSelectedPickId(pickId);
    setShowAssignModal(true);
  };

  const handleCloseAssignModal = () => {
    setShowAssignModal(false);
    setSelectedPickId(null);
  };
    const handleconfClose = () => {
    setConfirmModalData({
      id: 0,
      showconfModal: false,
      message: "",
    });
  };
  const onDeleteModalSubmit = async (isAccept: boolean) => {
    if (confirmModalData.id !== 0 && isAccept) {
      deletePickTicketById(confirmModalData.id.toString()).then(
        (response: ApiResponse<any>) => {
          if (response.status == 200) {
            toast.success("Pick Ticket deleted successfully");
            setRefreshTrigger((prev) => prev + 1);
          } else {
            toast.error("Failed to delete the Pick Ticket!");
          }
        }
      );
    }
    handleconfClose();
  };
  const handleDeleteAction = (row:any) => {
    console.log("Delete action for Pick ID:", row.id);
     setConfirmModalData({
      id: row.id,
      showconfModal: true,
      message: `Are you sure you want to delete this  Pick Ticket Id ${row.id}?`,
    });
  };
  const pageTabs = [
    { 
      order: 0, 
      name: "Ready to Pick", 
      tabLable: "Ready to Pick", 
      visibility: true, 
      status: true, 
      multiSelect: null,
      label: "Ready to Pick",
      content: null
    }, 
    { 
      order: 1, 
      name: "Partially Picked", 
      tabLable: "Partially Picked", 
      visibility: true, 
      status: true, 
      multiSelect: null,
      label: "Partially Picked",
      content: null
    },
    { 
      order: 2, 
      name: "Pick Complete", 
      tabLable: "Pick Complete", 
      visibility: true, 
      status: true, 
      multiSelect: null,
      label: "Pick Complete",
      content: null
    },
  ];

  useEffect(() => {
    resetSearch();
    setLoading(false);
    emit("show_client_warning", false);
  }, [resetSearch, emit]);

  return !loading ? (
    <>
      <div>
        <PickList
          db_columns={db_columns}
          search_columns={search_columns}
          columns={columns}
          pageName={pageName}
          headerName={headerName}
          addUrl="/outbound/pick/add"
          listUrl="/outbound/pick"
          pageTabs={pageTabs}
          buttonStatus={true}
          checkboxStatus={true}
          tableMultiSelect={null}
          clientId={clientId}
          onSelectedRowsChange={() => {}}
          refreshTrigger={refreshTrigger}

        />
      </div>
      <CommonModal
        show={showAssignModal}
        handleClose={handleCloseAssignModal}
        heading="Assign To"
        content={<AssignToUserLayout handleClose={handleCloseAssignModal} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        content={<>{confirmModalData.message}</>}
        onModalSubmit={onDeleteModalSubmit}
      />
    </>
  ) : (
    <Loader />
  );
}

PickOverview.defaultProps = defaultProps;
